import { isEmpty } from 'lodash';

import { CALL_API } from '../../middlewares/api';
import {
    REQUEST_BANK_CREDIT_CARD,
    RECEIVE_BANK_CREDIT_CARD,
    FAILURE_BANK_CREDIT_CARD
} from './constants';

const shouldFetchBankCreditCard = state => {
    const bankCreditCard = state.bankcreditcard.bankcreditcard;
    const fetching = state.bankcreditcard.fetching;

    if (fetching) {
        return false;
    } else if (isEmpty(bankCreditCard)) {
        return true;
    } else {
        return false;
    }
};

export const fetchBankCreditCardIfNeeded = () => {
    return {
        [CALL_API]: {
            endpoint: '/bank-credit-card',
            types: [REQUEST_BANK_CREDIT_CARD, RECEIVE_BANK_CREDIT_CARD, FAILURE_BANK_CREDIT_CARD],
            shouldCallAPI: state => shouldFetchBankCreditCard(state)
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/bankcreditcard/actions.js